import classNames from "classnames";
import Button from "../../../custom/button/button";
import styles from "../styles.module.scss";
import { baseUrl } from "../../../requests";
import { useAtomValue } from "jotai";
import { conferencePayment } from "../../../state";
import { formatCurrency } from "../../../utils/formatCurrency";
import usePayment from "../../../hooks/usePayment";

const PayForConference = ({
  amount,
  email,
}: {
  amount: number;
  email: string;
}) => {
  const { makePayment, isPending } = usePayment();
  const conferencePaymentDetails = useAtomValue(conferencePayment);

  const handlePayment = async () => {
    const payload: ProcessPaymentPayload = {
      RouteId: conferencePaymentDetails?.RouteId!,
      Amount: amount || conferencePaymentDetails?.Amount!,
      MembershipNo: email,
      Description: "Conference Payment",
      ReturnURL: `${baseUrl}/non-member-events/conference`,
      PaymentForm: "Conference",
      DataId: conferencePaymentDetails?.DataId!,
    };
    makePayment(payload, (data) => {
      const responseData = JSON.parse(data?.ResponsePayLoad) as PaymentDetails;
      window.location.href = responseData?.RedirectURL;
    });
  };

  return (
    <section className={classNames("card")}>
      <h2>Pay for Conference</h2>
      <div className={styles.line}></div>
      <p>
        You are one step away to complete your conference registration. Proceed
        to pay <b>{formatCurrency(amount)}</b> before the event date.
      </p>
      <br />
      <Button
        isLoading={isPending}
        disabled={isPending}
        onClick={handlePayment}
        type="button"
        text="Make Payment"
      />
    </section>
  );
};

export default PayForConference;
